import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=588e1cbc&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=588e1cbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588e1cbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588e1cbc')) {
      api.createRecord('588e1cbc', component.options)
    } else {
      api.reload('588e1cbc', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=588e1cbc&scoped=true", function () {
      api.rerender('588e1cbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/detail.vue"
export default component.exports